<template>
  <img
    src="~/assets/trilon-logo.svg"
    alt="Trilon - Next-level Application Consulting from NestJS and Angular Universal Core team members"
  />
</template>
